module.exports = __webpack_public_path__ + "love.dcf9cd99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/love.png
// module id = 2524
// module chunks = 0